/**
 * BossMoodDriver tunables — how boss phase transitions swell the scene
 * atmosphere. Each boss phase advance emits an escalating mood multiplier
 * (Lane E S1 — the Hollow Coil undercroft dais swell).
 *
 * The driver listens to EVENTS.BOSS_PHASE_CHANGED (already wired from the
 * server `bossPhaseChange` broadcast → NetworkManager → EventBus), tracks the
 * phase index per boss npcId, and emits EVENTS.BOSS_MOOD with the mapped
 * intensity. AtmosphereLayer MULTIPLIES it onto the per-level mood alongside
 * sceneMood (time-of-day) and combatMood (cast-heat):
 *
 *   final = sceneMood × combatMood × bossMood
 *
 * On NPC_DEFEATED the tracked boss is cleared and bossMood resets to 1
 * (neutral) so the atmosphere settles back after the fight. The undercroft's
 * base sceneMood (0.65) composes: 0.65 × 1 × 1.2 = 0.78 (phase 1 swell),
 * 0.65 × 1 × 1.45 = 0.94 (phase 2 climax) — the dais intensifies as the
 * Hollow Keeper escalates, then settles on defeat.
 */
export interface BossMoodConfig {
  /** Master switch (off → driver never starts, bossMood stays 1). */
  enabled: boolean;
  /** Escalating mood multipliers per boss phase index (0-based).
   *  1 = neutral (no swell); >1 = intensify the ambient layers.
   *  If a boss has more phases than entries, the last entry is reused. */
  phaseIntensities: number[];
  /** Neutral value — emitted when no boss fight is active (after defeat or
   *  before the first phase). AtmosphereLayer multiplies this onto the mood,
   *  so 1 = no effect. */
  neutral: number;
}

export const BOSS_MOOD: BossMoodConfig = {
  enabled: true,
  // Hollow Keeper: phase 1 "Fogbound" → 1.2 (subtle swell, the mist draws in),
  // phase 2 "Hollow Wrath" → 1.45 (clear climax, enraged).
  phaseIntensities: [1.2, 1.45],
  neutral: 1,
};
